import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import * as _ from 'lodash';

import {ActivityLogStructure} from '../../../main/models/activity-log-structure';
import {ErrorHandlerService} from '../../services/error-handler.service';
import {ActivityType} from '../../../main/models/activity-type';
import {EntitiesService} from '../../services/entitiesService.service';
import {AuthenticationService} from '../../services/authentication.service';

export const companyProps = ['_id', 'name', 'website', 'state', 'type'];
export const userProps = ['_id', 'lang', 'job_title', 'state', 'email', 'first_name', 'last_name',
  'mobile_number', 'user_type', 'customerId', 'txRole', 'userIdentifier'];
export const projectProps = ['_id', 'state', 'name', 'type'];

@Component({
  selector: 'app-add-activity-log',
  templateUrl: './add-activity-log.component.html',
  styleUrls: ['./add-activity-log.component.css']
})
export class AddActivityLogComponent implements OnInit {

  @Input('activityLog') activityLog: ActivityLogStructure;

  activityLogForm: FormGroup;
  activityTypes: ActivityType[];
  admins: {name: string, _id: string}[];

  types = 'todo';
  user: any;

  constructor(
    public bsModalRef: NgbActiveModal,
    private formBuilder: FormBuilder,
    private entitiesService: EntitiesService,
    private handler: ErrorHandlerService,
    private authenticationService: AuthenticationService,
  ) { }

  static formatData(type: string, value: any) {
    let targetedProps;
    switch (type) {
      case 'company':
        targetedProps = companyProps;
        break;

      case 'user':
        targetedProps = userProps;
        break;

      case 'project':
        targetedProps = projectProps;
        break;
    }

    return !targetedProps ? value : Array.isArray(value) ? value
      .map(item => _.pick(item, targetedProps)) : _.pick(value, targetedProps);
  }

  ngOnInit() {
    this.getActivityTypes();
    this.getAdminList();
    this.user = _.pick(this.authenticationService.getUser(), ['name', '_id']);
    this.initForm();
  }

  initForm() {
    this.activityLogForm = this.formBuilder.group({
      company: [{
        value: this.activityLog.company.defaultValue,
        disabled: !this.activityLog.company.isEditable,
      }, this.activityLog.company.validators],
      user: [{
        value: this.activityLog.user.defaultValue,
        disabled: !this.activityLog.user.isEditable,
      }, this.activityLog.user.validators],
      project: [{
        value: this.activityLog.project.defaultValue,
        disabled: !this.activityLog.project.isEditable,
      }, this.activityLog.project.validators],
      activityType: [_.get(this.activityLog, 'activityType.defaultValue'), [Validators.required]],
      type: [_.get(this.activityLog, 'type.defaultValue') || 'done', [Validators.required]],
      comment: [_.get(this.activityLog, 'comment.defaultValue'), [Validators.required]],
      assignee: [_.get(this.activityLog, 'assignee.defaultValue') || this.user, [Validators.required]],
      dueDate: [_.get(this.activityLog, 'dueDate.defaultValue') || new Date(), [Validators.required]],
    });
  }

  getActivityTypes() {
    this.entitiesService.getItems('activityType').subscribe(items => {
      this.activityTypes = items.map(item => _.pick(item, ['_id', 'name']));
    }, err => this.handler.handle(err));
  }

  getAdminList() {
    this.entitiesService.getAdminNames().subscribe((res: any) => {
      this.admins = res.data;
    });
  }

  loadDataFor(type: string) {
    const ids = this.activityLog[type].loadDataPaths
      .map(path => _.get(this.activityLogForm.getRawValue(), path));

    if (_.compact(ids).length !== this.activityLog[type].loadDataPaths.length) {
      this.activityLog[type].data = [];
      return;
    }

    this.activityLog.loadDataFor(type, ids);
  }

  submitActivityLog() {
    const activityRecord = this.activityLogForm.getRawValue();
    if (activityRecord.type === 'done') {
      activityRecord.completionDate = activityRecord.dueDate;
      delete activityRecord.dueDate;
    }

    if (!this.activityLog.isEditing) {
      return this.entitiesService.addRecords(this.activityLog.targetedType, this.activityLog.targetedId, activityRecord)
        .subscribe(() => this.bsModalRef.close(),  err => this.handler.handle(err));
    }

    return this.entitiesService.updateActivityLog(this.activityLog.targetedId, activityRecord)
      .subscribe(() => this.bsModalRef.close(),  err => this.handler.handle(err));
  }
}
